import React, { useState, useEffect } from "react";
import Credit from "../Credit/Credit";
import AppointmentItem from "../AppointmentItem/AppointmentItem";
import SelectedAppointment from "../SelectedAppointment/SelectedAppointment";
import _ from "lodash";
import {
  useMeetingListState,
  useUserMeetingListActions,
  useDrMeetingListActions,
} from "../../../providers/MeetingListProvider";
import * as HTTPServices from "../../../api/HTTPServices";
//if remove unused pusher it failed
/* eslint-disable no-unused-vars */
import Pusher from "pusher-js";
import Echo from "laravel-echo";
import sampleUser from "../../../assets/images/sampleUser/118-118.png";
import { useUserState } from "../../../providers/UserProvider";
import { useActiveRoomActions } from "../../../providers/ActiveRoomProvider";
import { COLORS } from "../../../lib/colors";
import ButtonComponent from "../../ButtonComponent";
import ringtone from "../../../assets/ringtones/ringtone.ogg";
import CircularProgress from "../../CircularProgress";
import ModalComponent from "../../ModalComponent";
import { useTranslation } from "react-i18next";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import List from "@mui/material/List";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Input } from "../../Input";
import { useLocation } from "react-router-dom";
import RequestVideoCallModal from "../../RequestVideoCall";
import * as Toast from "../../../lib/toast";
import AlertCall from "../../AlertCall";
import classes from "./Appointment.module.scss";

function Appointments({ onlineMembers }) {
  const { t } = useTranslation();
  const location = useLocation();

  const [selectedItem, setSelectedItem] = useState("");
  const [activeRoom, setActiveRoom] = useState();
  const [roomIsOpen, setRoomIsOpen] = useState(false);
  const [roomCall, setRoomCall] = useState("");
  const [showAllertCall, setShowAllertCall] = useState(false);
  const [getLinkLoading, setGetLinkLoading] = useState(false);
  const [requestedVideopatientName, setRequestedVideopatientName] =
    useState("");
  const user = useUserState();
  const meetingList = useMeetingListState();
  const { setUserMeetingList } = useUserMeetingListActions();
  const { setDrMeetingList } = useDrMeetingListActions();
  const { setCurrentRoom } = useActiveRoomActions();
  const [openVideoCallModall, setOpenVideoCallModall] = useState(false);
  const [openPrivateCallModall, setOpenPrivateCallModall] = useState(false);
  const [visitCondition, setVisitCondition] = useState("openVisits");
  const [search, setSearch] = useState("");
  const [activeTab, setActiveTab] = useState(0);

  const [todayMeet, setTodayMeet] = useState("");
  const [pastMeet, setPastMeet] = useState("");
  const [fetureMeet, setFetureMeet] = useState("");
  const [endedMeet, setEndedMeet] = useState("");
  const [UsersOpenVisits, setUsersOpenVisits] = useState("");
  const [videoCallRequestModal, setVideoCallRequestModal] = useState(false);
  const [loadingPatientVideoCallRequest, setLoadingPatientVideoCallRequest] =
    useState(false);

  useEffect(() => {
    if (user) {
      privateSocketLayerOne();
      const userType = user.user_login.approve;
      // console.log(`userType`, userType);
      if (userType === "doctor") {
        setDrMeetingList();
      }

      if (userType === "user") {
        setUserMeetingList();
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  useEffect(() => {
    if (meetingList) {
      const userType = user?.user_login?.approve;
      // console.log(`userType`, userType);
      if (userType === "doctor") {
        separateMeetings();
      }
      if (userType === "user") {
        let openedMeetings = [];
        let endedMeetings = [];
        _.map(meetingList, (meet) => {
          let visitStatus = meet.event_list[0].visit_status;
          if (visitStatus === "not_end") {
            openedMeetings.push(meet);
          }
          if (visitStatus === "end") {
            endedMeetings.push(meet);
          }
        });
        setUsersOpenVisits(openedMeetings);
        setEndedMeet(endedMeetings);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meetingList]);

  const separateMeetings = () => {
    let todayUtc = new Date().toJSON().slice(0, 10);
    let meetingKeys = Object.keys(meetingList);
    var todayMeetObj = "";
    var pastMeetObj = "";
    var fetureMeetObj = "";
    var endedMeetObj = "";

    _.map(meetingList, (meet) => {
      let meetDate = meet.event_list[0].data;
      let isoDate = meetDate.substring(0, 10);
      var userName = meet.user_info?.user_username;
      let newMeeting = meetingKeys.filter((meet) => meet === userName);
      let visitStatus = meet.event_list[0].visit_status;

      if (meetDate && isoDate === todayUtc && visitStatus === "not_end") {
        var todayMeet = Object.keys(meetingList)
          .filter((key) => newMeeting.includes(key))
          .reduce((obj, key) => {
            obj[key] = meetingList[key];
            return obj;
          }, {});
        todayMeetObj = Object.assign({}, todayMeetObj, todayMeet);
      } else if (meetDate && isoDate < todayUtc && visitStatus === "not_end") {
        var pastMeet = Object.keys(meetingList)
          .filter((key) => newMeeting.includes(key))
          .reduce((obj, key) => {
            obj[key] = meetingList[key];
            return obj;
          }, {});
        pastMeetObj = Object.assign({}, pastMeetObj, pastMeet);
      } else if (meetDate && isoDate > todayUtc && visitStatus === "not_end") {
        var fetureMeet = Object.keys(meetingList)
          .filter((key) => newMeeting.includes(key))
          .reduce((obj, key) => {
            obj[key] = meetingList[key];
            return obj;
          }, {});
        fetureMeetObj = Object.assign({}, fetureMeetObj, fetureMeet);
      } else if (visitStatus !== "not_end") {
        var endedMeet = Object.keys(meetingList)
          .filter((key) => newMeeting.includes(key))
          .reduce((obj, key) => {
            obj[key] = meetingList[key];
            return obj;
          }, {});

        let checkIfExist = Object.keys(endedMeet);
        if (!endedMeetObj.hasOwnProperty(checkIfExist)) {
          endedMeetObj = Object.assign({}, endedMeetObj, endedMeet);
        }
      } else {
        console.log("something went wrong in render meeting");
        return;
      }
    });

    setTimeout(() => {
      setTodayMeet(todayMeetObj);
      setPastMeet(pastMeetObj);
      setFetureMeet(fetureMeetObj);
      setEndedMeet(endedMeetObj);
    }, 500);
  };

  function a11yProps(index) {
    return {
      id: `scrollable-prevent-tab-${index}`,
      "aria-controls": `scrollable-prevent-tabpanel-${index}`,
    };
  }
  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-prevent-tabpanel-${index}`}
        aria-labelledby={`scrollable-prevent-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  const handleChangeTab = (event, newValue) => {
    setActiveTab(newValue);
  };

  const newEcho = () => {
    let echo = new Echo({
      broadcaster: "pusher",
      key: "7890123456",
      wsHost: "push.sbm24.com",
      wssPort: 6001,
      wsPort: 6001,
      disableStats: true,
      forceTLS: true,
      //enabledTransports: ['wss'],
      authEndpoint: "https://sandbox.sbm24.net/broadcasting/auth",
      auth: {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token_echo")}`,
          Accept: "application/json",
        },
      },
    });
    return echo;
  };
  const privateSocketLayerOne = () => {
    let EchoChannel = newEcho().private(`user.${user.user_login.client_id}`);
    EchoChannel.notification((action) => {
      console.log(`action.notif_type`, action.notif_type);
      // if (action.notif_type === "NewMessage") {
      //   var user_id = action.sender.id;
      //   var visits = LiveObject.state.meeting;

      //   _.map(visits, (alert) => {
      //     if (parseInt(alert.dr_info.doctor_key) === parseInt(user_id)) {
      //       var count = alert.dr_info.chat_count;
      //       count = count + 1;
      //       alert.dr_info.chat_count = count;

      //       if (
      //         LiveObject.state.KeyRoom &&
      //         LiveObject.state.KeyRoom.length !== 0 &&
      //         LiveObject.state.KeyRoom.dr_info.doctor_key == user_id
      //       ) {
      //         count = 0;
      //         alert.dr_info.chat_count = count;
      //       }

      //       setTimeout(() => {
      //         if (user_id) {
      //           let el = document.getElementById("member_" + user_id);
      //           el.classList.add("online", "public_online");
      //         }
      //       }, 200);
      //     }
      //   });
      //   setTimeout(() => {
      //     LiveObject.setState({
      //       meeting: visits,
      //     });
      //   }, 500);
      // }
      if (action.notif_type === "NewVideoCallBB") {
        let roomCall = action;
        setRoomCall(roomCall);
        setShowAllertCall(true);
      }

      if (action.notif_type === "NewVideoCall") {
        let roomCall = action;
        setRoomCall(roomCall);
        setRequestedVideopatientName(roomCall.fullname);
        setVideoCallRequestModal(true);
      }
      // if (action.notif_type === "entrance") {
      //   let enteranceMessage = action.message;
      //   LiveObject.setState({
      //     enteranceMessage,
      //     showSnackbar: true,
      //   });
      // }

      // if (action.notif_type === "NewSafeCall") {
      //   this.setState({
      //     showReciveCallDialoge: true,
      //   });
      // }
    });
  };

  const acceptcall = () => {
    setGetLinkLoading(true);
    if (roomCall.room_type === "skyroom") {
      // this.setState({
      //   load_response: true,
      // });
      // const params = new URLSearchParams();
      // var token = room_call.room_id;
      // var Live = this;
      // const RequestService = HTTPServices.postMethod(
      //   "sk_join",
      //   params,
      //   "true",
      //   "post",
      //   "false",
      //   token
      // );
      // RequestService.then(function (response) {
      //   Live.setState({
      //     load_response: false,
      //   });
      //   if (response) {
      //     Live.openTab(response.room_link);
      //     Live.setState({
      //       room_call: null,
      //       // room_link: response.room_link,
      //     });
      //   }
      // }).catch(function (error) {
      //   Live.setState({
      //     load_response: false,
      //   });
      // });
    } else if (roomCall.room_type === "sbm") {
      // var room_id = room_call.room_id;
      // var client_id = room_call.client_id;
      // _.map(LiveObject.state.meeting, (item) => {
      //   if (item.dr_info.doctor_key === client_id) {
      //     LiveObject.setState({
      //       StatusAccount: true,
      //       StatusRoom: true,
      //       access: false,
      //       KeyRoom: item,
      //       room_call: null,
      //       roomTokenVideo: room_id,
      //     });
      //   }
      // });
    } else if (roomCall.room_type === "bb") {
      let customerLink = roomCall.link;
      setTimeout(() => {
        window.open(customerLink, "_blank");
        closeAlertCall();
      }, 3000);
      // this.openTab(customerLink);
    }
  };

  const closeAlertCall = () => {
    setShowAllertCall(false);
    setRoomCall(null);
    setGetLinkLoading(false);
  };

  const selectAppointmentHandler = (item) => {
    setSelectedItem(item);
  };
  const onSelectAppointment = (item) => {
    if (
      activeRoom &&
      activeRoom.event_list[0].token === item.event_list[0].token
    ) {
      setRoomIsOpen(false);
      setActiveRoom("");
      setCurrentRoom("");
    } else if (
      activeRoom &&
      activeRoom.event_list[0].token !== item.event_list[0].token
    ) {
      setRoomIsOpen(true);
      setActiveRoom(item);
      setCurrentRoom(item);
    } else {
      setRoomIsOpen(true);
      setActiveRoom(item);
      setCurrentRoom(item);
    }
  };
  const videoCallHandler = () => {
    handleOpenVideoCallModall();
    const params = new URLSearchParams();

    if (selectedItem) {
      params.append("token", selectedItem.event_list[0].token);
    } else {
      params.append("token", roomCall.room_id);
    }

    const RequestService = HTTPServices.postMethod(
      "binjoo_video_call_request",
      params,
      "true"
    );
    RequestService.then(function (response) {
      if (response) {
        handleCloseVideoCallModall();
        let drLink = response.doctor;

        let isSafari = window.safari !== undefined;
        if (isSafari) {
          setTimeout(() => {
            window.location.href = drLink;
          }, 100);
        } else {
          window.open(drLink, "_blank");
        }
        setVideoCallRequestModal(false);
      }
    });
  };
  const handleVideoCallRequest = () => {
    setLoadingPatientVideoCallRequest(true);
    const params = new URLSearchParams();
    params.append("doctor", selectedItem.dr_info.doctor_key);
    params.append("room_token", selectedItem.event_list[0].token);

    const RequestService = HTTPServices.postMethod(
      "video_call_request",
      params,
      "true"
    );
    RequestService.then(function (response) {
      Toast.SuccessData("request video call has been sent to docter");
      setVideoCallRequestModal(false);
      setLoadingPatientVideoCallRequest(false);
    }).catch(function (error) {
      Toast.ErrorData("cant stablish connection");
      setLoadingPatientVideoCallRequest(false);
    });
  };

  const privateCallHandler = () => {
    setOpenPrivateCallModall(true);
  };

  const handleOpenVideoCallModall = () => {
    setOpenVideoCallModall(true);
  };

  const handleCloseVideoCallModall = () => {
    setOpenVideoCallModall(false);
  };

  const RenderMeetingList = () => {
    if (!meetingList) {
      return <CircularProgress />;
    } else {
      let a = meetingList;
      let b = JSON.stringify(a);

      let noActiveVisit = b.includes("not_end");

      if (!noActiveVisit) {
        return (
          <div>
            <div className={classes.flexCenter}>
              <div> No active visit </div>
            </div>
            <div className={classes.flexCenter}>
              <a href="https://sbm24.com/search">
                <ButtonComponent backgroundColor={COLORS.primary} width={200}>
                  get visit
                </ButtonComponent>
              </a>
            </div>
          </div>
        );
      } else if (meetingList && user && user.user_login.approve === "user") {
        if (visitCondition === "openVisits") {
          return _.map(UsersOpenVisits, (item) => {
            if (
              selectedItem &&
              item.dr_info.doctor_key !== selectedItem.dr_info.doctor_key
            ) {
              return (
                <AppointmentItem
                  key={item.event_list[0].token}
                  name={item.dr_info.doctor_name}
                  image={item.dr_info.doctor_image || sampleUser}
                  specialty={item.dr_info.doctor_job_title}
                  onClick={() => setSelectedItem(item)}
                  onlineMembers={onlineMembers}
                  item={item}
                />
              );
            } else if (
              selectedItem &&
              item.dr_info.doctor_key === selectedItem.dr_info.doctor_key
            ) {
              return (
                <SelectedAppointment
                  key={item.event_list[0].token}
                  name={item.dr_info.doctor_name}
                  image={item.dr_info.doctor_image || sampleUser}
                  title={item.dr_info.doctor_job_title}
                  chatBtnTxt={
                    item.event_list[0].token !==
                      selectedItem.event_list[0].token ||
                    !roomIsOpen ||
                    location.pathname === "/dashboard"
                      ? t("components.Layout.SelectedAppointment.enterChat")
                      : t("components.Layout.SelectedAppointment.exitChat")
                  }
                  onSelectAppointment={() => {
                    onSelectAppointment(item);
                  }}
                  link={
                    (!roomIsOpen && !activeRoom) ||
                    location.pathname === "/dashboard" ||
                    (roomIsOpen &&
                      item.event_list[0].token !==
                        selectedItem.event_list[0].token)
                      ? `/appointment/?audience=${item.dr_info.doctor_key}&token=${item.event_list[0].token}`
                      : "/dashboard"
                  }
                  chatBtnBackColor={
                    (activeRoom &&
                      item.event_list[0].token !==
                        activeRoom.event_list[0].token) ||
                    !roomIsOpen ||
                    location.pathname === "/dashboard"
                      ? COLORS.lightPurple
                      : COLORS.error
                  }
                  textColor={
                    (activeRoom &&
                      item.event_list[0].token !==
                        activeRoom.event_list[0].token) ||
                    !roomIsOpen ||
                    location.pathname === "/dashboard"
                      ? COLORS.purple
                      : COLORS.red
                  }
                  onPatientVideoCallRequest={() =>
                    setVideoCallRequestModal(true)
                  }
                  audienceId={selectedItem.dr_info.doctor_key}
                  visitToken={selectedItem.event_list[0].token}
                  onlineMembers={onlineMembers}
                  item={item}
                  closeSelectedItem={() => {
                    setSelectedItem("");
                  }}
                />
              );
            } else {
              return (
                <AppointmentItem
                  key={item.event_list[0].token}
                  name={item.dr_info.doctor_name}
                  image={item.dr_info.doctor_image || sampleUser}
                  specialty={item.dr_info.doctor_job_title}
                  onClick={() => {
                    selectAppointmentHandler(item);
                  }}
                  onlineMembers={onlineMembers}
                  item={item}
                />
              );
            }
          });
        } else {
          return _.map(endedMeet, (item) => {
            if (
              selectedItem &&
              item.dr_info.doctor_key !== selectedItem.dr_info.doctor_key
            ) {
              return (
                <AppointmentItem
                  key={item.event_list[0].token}
                  name={item.dr_info.doctor_name}
                  image={item.dr_info.doctor_image || sampleUser}
                  specialty={item.dr_info.doctor_job_title}
                  onClick={() => setSelectedItem(item)}
                  onlineMembers={onlineMembers}
                  item={item}
                />
              );
            } else if (
              selectedItem &&
              item.dr_info.doctor_key === selectedItem.dr_info.doctor_key
            ) {
              return (
                <SelectedAppointment
                  key={item.event_list[0].token}
                  name={item.dr_info.doctor_name}
                  image={item.dr_info.doctor_image || sampleUser}
                  title={item.dr_info.doctor_job_title}
                  chatBtnTxt={
                    item.event_list[0].token !==
                      selectedItem.event_list[0].token ||
                    !roomIsOpen ||
                    location.pathname === "/dashboard"
                      ? t("components.Layout.SelectedAppointment.enterChat")
                      : t("components.Layout.SelectedAppointment.exitChat")
                  }
                  onSelectAppointment={() => {
                    onSelectAppointment(item);
                  }}
                  link={
                    (!roomIsOpen && !activeRoom) ||
                    location.pathname === "/dashboard" ||
                    (roomIsOpen &&
                      item.event_list[0].token !==
                        selectedItem.event_list[0].token)
                      ? `/appointment/?audience=${item.dr_info.doctor_key}&token=${item.event_list[0].token}`
                      : "/dashboard"
                  }
                  chatBtnBackColor={
                    (activeRoom &&
                      item.event_list[0].token !==
                        activeRoom.event_list[0].token) ||
                    !roomIsOpen ||
                    location.pathname === "/dashboard"
                      ? COLORS.primary
                      : COLORS.error
                  }
                  textColor={
                    (activeRoom &&
                      item.event_list[0].token !==
                        activeRoom.event_list[0].token) ||
                    !roomIsOpen ||
                    location.pathname === "/dashboard"
                      ? COLORS.purple
                      : COLORS.red
                  }
                  audienceId={selectedItem.dr_info.doctor_key}
                  visitToken={selectedItem.event_list[0].token}
                  onlineMembers={onlineMembers}
                  item={item}
                  closeSelectedItem={() => {
                    setSelectedItem("");
                  }}
                />
              );
            } else {
              return (
                <AppointmentItem
                  key={item.event_list[0].token}
                  name={item.dr_info.doctor_name}
                  image={item.dr_info.doctor_image || sampleUser}
                  specialty={item.dr_info.doctor_job_title}
                  onlineMembers={onlineMembers}
                  item={item}
                  onClick={() => {
                    selectAppointmentHandler(item);
                  }}
                />
              );
            }
          });
        }
      }
    }
  };

  const RenderTodayMeetingList = () => {
    return _.map(todayMeet, (item) => {
      if (
        selectedItem &&
        item.user_info.user_key !== selectedItem.user_info.user_key
      ) {
        return (
          <AppointmentItem
            key={item.event_list[0].token}
            name={item.user_info.user_name}
            image={item.user_info.user_image || sampleUser}
            onlineMembers={onlineMembers}
            item={item}
            onClick={() => {
              selectAppointmentHandler(item);
            }}
          />
        );
      } else if (
        selectedItem &&
        item.user_info.user_key === selectedItem.user_info.user_key
      ) {
        return (
          <SelectedAppointment
            key={item.event_list[0].token}
            name={selectedItem && selectedItem.user_info.user_name}
            image={
              (selectedItem && selectedItem.user_info.user_image) || sampleUser
            }
            chatBtnTxt={
              (activeRoom &&
                item.event_list[0].token !== activeRoom.event_list[0].token) ||
              !roomIsOpen ||
              location.pathname === "/dashboard"
                ? t("components.Layout.SelectedAppointment.enterChat")
                : t("components.Layout.SelectedAppointment.exitChat")
            }
            onSelectAppointment={() => {
              onSelectAppointment(item);
            }}
            link={
              (!roomIsOpen && !activeRoom) ||
              location.pathname === "/dashboard" ||
              (roomIsOpen &&
                item.event_list[0].token !== activeRoom.event_list[0].token)
                ? `/appointment/?audience=${item.user_info.user_key}&token=${item.event_list[0].token}`
                : "/dashboard"
            }
            onVideoCall={(item) => {
              videoCallHandler(item);
            }}
            onPrivateCall={(item) => {
              privateCallHandler(item);
            }}
            chatBtnBackColor={
              (activeRoom &&
                item.event_list[0].token !== activeRoom.event_list[0].token) ||
              !roomIsOpen ||
              location.pathname === "/dashboard"
                ? COLORS.primary
                : COLORS.error
            }
            textColor={
              (activeRoom &&
                item.event_list[0].token !== activeRoom.event_list[0].token) ||
              !roomIsOpen ||
              location.pathname === "/dashboard"
                ? COLORS.purple
                : COLORS.red
            }
            audienceId={selectedItem.user_info.user_key}
            visitToken={selectedItem.event_list[0].token}
            onlineMembers={onlineMembers}
            item={item}
            closeSelectedItem={() => {
              setSelectedItem("");
            }}
          />
        );
      } else {
        return (
          <AppointmentItem
            key={item.event_list[0].token}
            name={item.user_info.user_name}
            image={item.user_info.user_image || sampleUser}
            onlineMembers={onlineMembers}
            item={item}
            onClick={() => {
              selectAppointmentHandler(item);
            }}
          />
        );
      }
    });
  };

  const RenderPastMeetingList = () => {
    return _.map(pastMeet, (item) => {
      if (
        selectedItem &&
        item.user_info.user_key !== selectedItem.user_info.user_key
      ) {
        return (
          <AppointmentItem
            key={item.event_list[0].token}
            name={item.user_info.user_name}
            image={item.user_info.user_image || sampleUser}
            onlineMembers={onlineMembers}
            item={item}
            onClick={() => {
              selectAppointmentHandler(item);
            }}
          />
        );
      } else if (
        selectedItem &&
        item.user_info.user_key === selectedItem.user_info.user_key
      ) {
        return (
          <SelectedAppointment
            key={item.event_list[0].token}
            name={selectedItem && selectedItem.user_info.user_name}
            image={
              (selectedItem && selectedItem.user_info.user_image) || sampleUser
            }
            chatBtnTxt={
              (activeRoom &&
                item.event_list[0].token !== activeRoom.event_list[0].token) ||
              !roomIsOpen ||
              location.pathname === "/dashboard"
                ? t("components.Layout.SelectedAppointment.enterChat")
                : t("components.Layout.SelectedAppointment.exitChat")
            }
            onSelectAppointment={() => {
              onSelectAppointment(item);
            }}
            link={
              (!roomIsOpen && !activeRoom) ||
              location.pathname === "/dashboard" ||
              (roomIsOpen &&
                item.event_list[0].token !== activeRoom.event_list[0].token)
                ? `/appointment/?audience=${item.user_info.user_key}&token=${item.event_list[0].token}`
                : "/dashboard"
            }
            onVideoCall={(item) => {
              videoCallHandler(item);
            }}
            onPrivateCall={(item) => {
              privateCallHandler(item);
            }}
            chatBtnBackColor={
              (activeRoom &&
                item.event_list[0].token !== activeRoom.event_list[0].token) ||
              !roomIsOpen ||
              location.pathname === "/dashboard"
                ? COLORS.primary
                : COLORS.error
            }
            textColor={
              (activeRoom &&
                item.event_list[0].token !== activeRoom.event_list[0].token) ||
              !roomIsOpen ||
              location.pathname === "/dashboard"
                ? COLORS.purple
                : COLORS.red
            }
            audienceId={selectedItem.user_info.user_key}
            visitToken={selectedItem.event_list[0].token}
            onlineMembers={onlineMembers}
            item={item}
            closeSelectedItem={() => {
              setSelectedItem("");
            }}
          />
        );
      } else {
        return (
          <AppointmentItem
            key={item.event_list[0].token}
            name={item.user_info.user_name}
            image={item.user_info.user_image || sampleUser}
            onlineMembers={onlineMembers}
            item={item}
            onClick={() => {
              selectAppointmentHandler(item);
            }}
          />
        );
      }
    });
  };

  const RenderFetureMeetingList = () => {
    return _.map(fetureMeet, (item) => {
      if (
        selectedItem &&
        item.user_info.user_key !== selectedItem.user_info.user_key
      ) {
        return (
          <AppointmentItem
            key={item.event_list[0].token}
            name={item.user_info.user_name}
            image={item.user_info.user_image || sampleUser}
            onlineMembers={onlineMembers}
            item={item}
            onClick={() => {
              selectAppointmentHandler(item);
            }}
          />
        );
      } else if (
        selectedItem &&
        item.user_info.user_key === selectedItem.user_info.user_key
      ) {
        return (
          <SelectedAppointment
            key={item.event_list[0].token}
            name={selectedItem && selectedItem.user_info.user_name}
            image={
              (selectedItem && selectedItem.user_info.user_image) || sampleUser
            }
            chatBtnTxt={
              (activeRoom &&
                item.event_list[0].token !== activeRoom.event_list[0].token) ||
              !roomIsOpen ||
              location.pathname === "/dashboard"
                ? t("components.Layout.SelectedAppointment.enterChat")
                : t("components.Layout.SelectedAppointment.exitChat")
            }
            textColor={
              (activeRoom &&
                item.event_list[0].token !== activeRoom.event_list[0].token) ||
              !roomIsOpen ||
              location.pathname === "/dashboard"
                ? COLORS.purple
                : COLORS.red
            }
            onSelectAppointment={() => {
              onSelectAppointment(item);
            }}
            link={
              (!roomIsOpen && !activeRoom) ||
              location.pathname === "/dashboard" ||
              (roomIsOpen &&
                item.event_list[0].token !== activeRoom.event_list[0].token)
                ? `/appointment/?audience=${item.user_info.user_key}&token=${item.event_list[0].token}`
                : "/dashboard"
            }
            onVideoCall={(item) => {
              videoCallHandler(item);
            }}
            onPrivateCall={(item) => {
              privateCallHandler(item);
            }}
            chatBtnBackColor={
              (activeRoom &&
                item.event_list[0].token !== activeRoom.event_list[0].token) ||
              !roomIsOpen ||
              location.pathname === "/dashboard"
                ? COLORS.primary
                : COLORS.error
            }
            audienceId={selectedItem.user_info.user_key}
            visitToken={selectedItem.event_list[0].token}
            onlineMembers={onlineMembers}
            item={item}
            closeSelectedItem={() => {
              setSelectedItem("");
            }}
          />
        );
      } else {
        return (
          <AppointmentItem
            key={item.event_list[0].token}
            name={item.user_info.user_name}
            image={item.user_info.user_image || sampleUser}
            onlineMembers={onlineMembers}
            item={item}
            onClick={() => {
              selectAppointmentHandler(item);
            }}
          />
        );
      }
    });
  };

  const renderClosedList = () => {
    if (meetingList && user) {
      return _.map(endedMeet, (item) => {
        if (
          selectedItem &&
          item.user_info.user_key !== selectedItem.user_info.user_key
        ) {
          return (
            <AppointmentItem
              key={item.event_list[0].token}
              name={item.user_info.user_name}
              image={item.user_info.user_image || sampleUser}
              onlineMembers={onlineMembers}
              item={item}
              onClick={() => {
                selectAppointmentHandler(item);
              }}
            />
          );
        } else if (
          selectedItem &&
          item.user_info.user_key === selectedItem.user_info.user_key
        ) {
          return (
            <SelectedAppointment
              key={item.event_list[0].token}
              name={selectedItem && selectedItem.user_info.user_name}
              image={
                (selectedItem && selectedItem.user_info.user_image) ||
                sampleUser
              }
              chatBtnTxt={
                (activeRoom &&
                  item.event_list[0].token !==
                    activeRoom.event_list[0].token) ||
                !roomIsOpen ||
                location.pathname === "/dashboard"
                  ? t("components.Layout.SelectedAppointment.enterChat")
                  : t("components.Layout.SelectedAppointment.exitChat")
              }
              onSelectAppointment={() => {
                onSelectAppointment(item);
              }}
              link={
                (!roomIsOpen && !activeRoom) ||
                location.pathname === "/dashboard" ||
                (roomIsOpen &&
                  item.event_list[0].token !== activeRoom.event_list[0].token)
                  ? `/appointment/?audience=${item.user_info.user_key}&token=${item.event_list[0].token}`
                  : "/dashboard"
              }
              onVideoCall={(item) => {
                videoCallHandler(item);
              }}
              onPrivateCall={(item) => {
                privateCallHandler(item);
              }}
              chatBtnBackColor={
                (activeRoom &&
                  item.event_list[0].token !==
                    activeRoom.event_list[0].token) ||
                !roomIsOpen ||
                location.pathname === "/dashboard"
                  ? COLORS.primary
                  : COLORS.error
              }
              textColor={
                (activeRoom &&
                  item.event_list[0].token !==
                    activeRoom.event_list[0].token) ||
                !roomIsOpen ||
                location.pathname === "/dashboard"
                  ? COLORS.purple
                  : COLORS.red
              }
              audienceId={selectedItem.user_info.user_key}
              visitToken={selectedItem.event_list[0].token}
              onlineMembers={onlineMembers}
              item={item}
              closeSelectedItem={() => {
                setSelectedItem("");
              }}
            />
          );
        } else {
          return (
            <AppointmentItem
              key={item.event_list[0].token}
              name={item.user_info.user_name}
              image={item.user_info.user_image || sampleUser}
              onlineMembers={onlineMembers}
              item={item}
              onClick={() => {
                selectAppointmentHandler(item);
              }}
            />
          );
        }
      });
    }
  };

  const SearchList = (meeting) => {
    let user = [];
    _.map(meeting, (item) => {
      user.push(item.user_info.user_name);
    });

    return filterItems(search, user);
  };

  const filterItems = (needle, heystack) => {
    let query = needle.toLowerCase();
    return heystack.filter((item) => item.toLowerCase().indexOf(query) >= 0);
  };

  const renderSearchedItems = () => {
    let requestSearch = SearchList(meetingList);
    return _.map(meetingList, (item) => {
      if (search) {
        if (requestSearch.indexOf(item.user_info.user_name) >= 0) {
          //

          if (
            selectedItem &&
            item.user_info.user_key !== selectedItem.user_info.user_key
          ) {
            return (
              <AppointmentItem
                key={item.event_list[0].token}
                name={item.user_info.user_name}
                image={item.user_info.user_image || sampleUser}
                item={item}
                onClick={() => {
                  selectAppointmentHandler(item);
                }}
              />
            );
          } else if (
            selectedItem &&
            item.user_info.user_key === selectedItem.user_info.user_key
          ) {
            return (
              <SelectedAppointment
                key={item.event_list[0].token}
                name={selectedItem && selectedItem.user_info.user_name}
                image={
                  (selectedItem && selectedItem.user_info.user_image) ||
                  sampleUser
                }
                chatBtnTxt={
                  (activeRoom &&
                    item.event_list[0].token !==
                      activeRoom.event_list[0].token) ||
                  !roomIsOpen ||
                  location.pathname === "/dashboard"
                    ? t("components.Layout.SelectedAppointment.enterChat")
                    : t("components.Layout.SelectedAppointment.exitChat")
                }
                onSelectAppointment={() => {
                  onSelectAppointment(item);
                }}
                link={
                  (!roomIsOpen && !activeRoom) ||
                  location.pathname === "/dashboard" ||
                  (roomIsOpen &&
                    item.event_list[0].token !== activeRoom.event_list[0].token)
                    ? `/appointment/?audience=${item.user_info.user_key}&token=${item.event_list[0].token}`
                    : "/dashboard"
                }
                onVideoCall={(item) => {
                  videoCallHandler(item);
                }}
                onPrivateCall={(item) => {
                  privateCallHandler(item);
                }}
                chatBtnBackColor={
                  (activeRoom &&
                    item.event_list[0].token !==
                      activeRoom.event_list[0].token) ||
                  !roomIsOpen ||
                  location.pathname === "/dashboard"
                    ? COLORS.primary
                    : COLORS.error
                }
                textColor={
                  (activeRoom &&
                    item.event_list[0].token !==
                      activeRoom.event_list[0].token) ||
                  !roomIsOpen ||
                  location.pathname === "/dashboard"
                    ? COLORS.purple
                    : COLORS.red
                }
                audienceId={selectedItem.user_info.user_key}
                visitToken={selectedItem.event_list[0].token}
                onlineMembers={onlineMembers}
                item={item}
                closeSelectedItem={() => {
                  setSelectedItem("");
                }}
              />
            );
          } else {
            return (
              <AppointmentItem
                key={item.event_list[0].token}
                name={item.user_info.user_name}
                image={item.user_info.user_image || sampleUser}
                onlineMembers={onlineMembers}
                item={item}
                onClick={() => {
                  selectAppointmentHandler(item);
                }}
              />
            );
          }
        }
      }
    });
  };

  const renderSeparateVisits = () => {
    return (
      <>
        <Tabs
          value={activeTab}
          // indicatorColor="yellow"
          onChange={handleChangeTab}
          centered
          TabIndicatorProps={{ style: { background: "#f7b500" } }}
        >
          <Tab
            className={classes.tabBtn}
            label={t("components.Layout.Appointments.separateMeetings.today")}
            {...a11yProps(0)}
          />
          <Tab
            className={classes.tabBtn}
            label={t("components.Layout.Appointments.separateMeetings.past")}
            {...a11yProps(1)}
          />
          <Tab
            className={classes.tabBtn}
            label={t("components.Layout.Appointments.separateMeetings.future")}
            {...a11yProps(2)}
          />
        </Tabs>
        <TabPanel
          className={classes.tabPanContainer}
          value={activeTab}
          index={0}
        >
          <List style={{ minWidth: "100%" }}>
            {!meetingList && <CircularProgress />}
            {todayMeet && RenderTodayMeetingList()}
          </List>
        </TabPanel>
        <TabPanel
          className={classes.tabPanContainer}
          value={activeTab}
          index={1}
        >
          <List style={{ minWidth: "100%" }}>
            {!meetingList && <CircularProgress />}
            {pastMeet && RenderPastMeetingList()}
          </List>
        </TabPanel>
        <TabPanel
          className={classes.tabPanContainer}
          value={activeTab}
          index={2}
        >
          <List style={{ minWidth: "100%" }}>
            {!meetingList && <CircularProgress />}
            {fetureMeet && RenderFetureMeetingList()}
          </List>
        </TabPanel>
      </>
    );
  };

  const renderAppoitmentPanel = () => {
    switch (user?.user_login?.approve) {
      case "user":
        return (
          <>
            <Credit />
            <div className={classes.visitCategory}>
              <div>
                <ButtonComponent
                  backgroundColor={COLORS.white}
                  className={classes.categoryBtn}
                  onClick={() => {
                    setVisitCondition("openVisits");
                  }}
                  textColor={COLORS.purple}
                >
                  {t(
                    "components.Layout.Appointments.separateMeetings.openedVisits"
                  )}
                </ButtonComponent>
                <div
                  className={
                    visitCondition === "openVisits"
                      ? classes.activeContainer
                      : classes.deActiveContainer
                  }
                ></div>
              </div>
              <div>
                <ButtonComponent
                  backgroundColor={COLORS.white}
                  onClick={() => {
                    setVisitCondition("closedVisits");
                  }}
                  textColor={COLORS.purple}
                >
                  {t(
                    "components.Layout.Appointments.separateMeetings.closedVisit"
                  )}
                </ButtonComponent>
                <div
                  className={
                    visitCondition === "closedVisits"
                      ? classes.activeContainer
                      : classes.deActiveContainer
                  }
                ></div>
              </div>
            </div>
            {RenderMeetingList()}
          </>
        );
      case "doctor":
        return (
          <>
            <Input
              label={t("components.Layout.Appointments.search")}
              onChange={(e) => {
                setSearch(e.target.value);
              }}
              fullWidth
            />
            <div className={classes.visitCategory}>
              <div>
                <ButtonComponent
                  backgroundColor={COLORS.white}
                  className={classes.categoryBtn}
                  onClick={() => {
                    setVisitCondition("openVisits");
                  }}
                  textColor={COLORS.purple}
                >
                  {t(
                    "components.Layout.Appointments.separateMeetings.openedVisits"
                  )}
                </ButtonComponent>
                <div
                  className={
                    visitCondition === "openVisits"
                      ? classes.activeContainer
                      : classes.deActiveContainer
                  }
                ></div>
              </div>
              <div>
                <ButtonComponent
                  backgroundColor={COLORS.white}
                  onClick={() => {
                    setVisitCondition("closedVisits");
                  }}
                  textColor={COLORS.purple}
                >
                  {t(
                    "components.Layout.Appointments.separateMeetings.closedVisit"
                  )}
                </ButtonComponent>
                <div
                  className={
                    visitCondition === "closedVisits"
                      ? classes.activeContainer
                      : classes.deActiveContainer
                  }
                ></div>
              </div>
            </div>

            {visitCondition === "openVisits" &&
              search === "" &&
              renderSeparateVisits()}
            {visitCondition === "closedVisits" &&
              search === "" &&
              renderClosedList()}
            {search && renderSearchedItems()}

            <ModalComponent
              open={openPrivateCallModall}
              handleClose={() => {
                setOpenPrivateCallModall(false);
              }}
              closeBtn={true}
              confirmBtn={false}
              title={t("components.Layout.Appointments.privateCallModal.title")}
            >
              <div className={classes.videocalModallChildren}>
                <p>{t("components.Layout.Appointments.privateCallModal.p")}</p>
              </div>
            </ModalComponent>
          </>
        );

      default:
        break;
    }
  };

  return (
    <div>
      <div
        className={
          user?.user_login?.approve === "user"
            ? classes.scrollableAppointmentList
            : classes.scrollableAppointmentListDr
        }
      >
        {renderAppoitmentPanel()}
      </div>
      <ModalComponent
        open={openVideoCallModall}
        handleClose={handleCloseVideoCallModall}
        closeBtn={true}
        confirmBtn={false}
        title={t("components.Layout.Appointments.videoCallModall.title")}
      >
        <div className={classes.videocalModallChildren}>
          <p>{t("components.Layout.Appointments.videoCallModall.p1")}</p>
          <p>{t("components.Layout.Appointments.videoCallModall.p2")}</p>
        </div>
      </ModalComponent>
      <RequestVideoCallModal
        handleOpenVideoCallRequest={videoCallRequestModal}
        handleCloseVideoCallRequest={() => {
          setVideoCallRequestModal(false);
        }}
        handleVideoCallRequest={handleVideoCallRequest}
        loadingRequest={loadingPatientVideoCallRequest}
        name={requestedVideopatientName}
        handleConfirmCall={videoCallHandler}
      />
      <AlertCall
        openAlertCall={showAllertCall}
        closeAlertCall={closeAlertCall}
        acceptCall={acceptcall}
        roomCall={roomCall}
        defaultUserImage={sampleUser}
        ringtone={ringtone}
        loading={getLinkLoading}
      />
    </div>
  );
}

export default Appointments;
